import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Home from "../pages/Home/Home";
import Home2 from "../pages/Home/Home2";
import ContactUs from "../pages/ContactUs/ContactUs";
import { LanguageProvider } from "../useContext/LanguageContext";
import { Route, Routes, Navigate } from "react-router-dom";
import JoinAsCommittieMember from "../pages/GetInvolved/JoinAsCommittieMember";
import JoinAsADonor from "../pages/GetInvolved/JoinAsADonor";
import JoinAsAVolunteer from "../pages/GetInvolved/JoinAsAVolunteer";
import RegisterTempleForm from "../pages/GetInvolved/RegisterTemple";
import JoinAsAPujari from "../pages/GetInvolved/JoinAsAPujari";
import Donation from "../pages/Donation/Donation";
import PujaShops from "../pages/GetInvolved/PujaShop";
import ExploreOurMission from "../pages/ExploreOurMission/ExploreOurMission";
import AdoptNow from "../pages/AdoptNow/AdoptNow";
import HeritageDevelopmentCommittee from "../pages/Committees/HeritageDevelopmentCommittee";
import CommunityUpliftmentCommittee from "../pages/Committees/CommunityUpliftmentCommittee";
import VikasCommittee from "../pages/Committees/VikasCommittee";
import BharatJalSanrakshanCommittee from "../pages/Committees/BharatJalSanrakshanCommittee";
import ShaktiBharatMissionCommitte from "../pages/Committees/ShaktiBharatMissionCommitte";
import PrivacyPolicy from "../pages/Policies/PrivacyPolicy";
import TermsAndConditions from "../pages/Policies/TermsAndConditions";
import AboutUs from "../pages/AboutUs/AboutUs";
import AdoptACowForm from "../pages/AdoptNow/AdoptACowForm";
import AdoptATempleForm from "../pages/AdoptNow/AdoptATempleForm";
import AdoptATreeForm from "../pages/AdoptNow/AdoptATreeForm";
import OurTeam from "../pages/OurTeam/OurTeam";
import MahasangamYatra from "../pages/GetInvolved/MahasangamYatra";
import VolunteerReport from "../pages/Reports/VolunteerReport";
import DonorReport from "../pages/Reports/DonorReport";
import PujariReport from "../pages/Reports/PujariReport";
import PujashopReport from "../pages/Reports/PujashopReport";
import TempleRegistrationReport from "../pages/Reports/TempleRegistrationReport";
import ThankYou from "../pages/GetInvolved/ThankYou";
import JIND_12_MAR_2025 from "../pages/YatraPressRelease/12032025-jind";
import SISAYE_13_MAR_2025 from "../pages/YatraPressRelease/13032025-sisaye";
import MAHIPALPUR_13_MAR_2025 from "../pages/YatraPressRelease/13032025-mahipalpur";
import HISAR_12_MAR_2025 from "../pages/YatraPressRelease/12032025-hisar";
import HARIDWAR_08_MAR_2025 from "../pages/YatraPressRelease/08032025-haridwar";
import HARIDWAR_07_MAR_2025 from "../pages/YatraPressRelease/07032025-haridwar";
import BADAYU_05_MAR_2025 from "../pages/YatraPressRelease/05032025-badayu-sambhal";
import EventRegistration from "../pages/Events/EventRegistration";
import EventRegistrationReport from "../pages/Reports/EventRegistrationReport";
import AllEventsGallery from "../pages/AllEventsGallery/AllEventsGallery";
import AllReleases from "../components/AllReleases";
import PRAYAGRAJ_02_MAR_2025 from "../pages/YatraPressRelease/02032025-prayagraj";
import BADAYU_06_MAR_2025 from "../pages/YatraPressRelease/06032025-badayu";
import DELHI_24_FEB_2025 from "../pages/YatraPressRelease/24022025-Delhi";
import DELHI_27_FEB_2025 from "../pages/YatraPressRelease/27022025-Delhi";
import MEERUT_07_MAR_2025 from "../pages/YatraPressRelease/07032025-Meerut";
import AYODHYA_03_MAR_2025 from "../pages/YatraPressRelease/03032025-ayodhya";
import SAMBAL_05_MAR_2025 from "../pages/YatraPressRelease/05032025-sambal";
import ODISHA_PURI_29012025 from "../pages/YatraPressRelease/29012025-puri";
import ODISHA_BHUBNESHWAR_29012025 from "../pages/YatraPressRelease/30012025-Bhuvaneshwar";
import RANCHI_05022025 from "../pages/YatraPressRelease/05022025-ranchi";
import SOMNATH_TEMPLE_12022025 from "../pages/YatraPressRelease/12022025-somnath-temple";
import RAMESWARAN_05022025 from "../pages/YatraPressRelease/05022025-Rameswaran";
import AGRA_ from "../pages/YatraPressRelease/-agra";
import AHMEDABAD_14022025 from "../pages/YatraPressRelease/14022025-Ahmedabad";
import ANDHRAPRADESH_01022025 from "../pages/YatraPressRelease/01022025-andhrapradesh";
import MAHARASHTRA_BHIMSHANKAR_08022025 from "../pages/YatraPressRelease/08022025-maharashtra-bhimshankar";
import GUJRAT_DWARKA from "../pages/YatraPressRelease/gujrat-dwarka";
import DELHI_SOMNATH_10022025 from "../pages/YatraPressRelease/10022025-delhi-somnath";
import SURAT_12022025 from "../pages/YatraPressRelease/12022025-surat";
import UJJAIN_12022025 from "../pages/YatraPressRelease/15022025-ujjain";
import ANDHRAPRADESH_03022025 from "../pages/YatraPressRelease/03022025-andhrapradesh";
import DELHI_10022025 from "../pages/YatraPressRelease/1002025-delhi";
import NASIK_10022025 from "../pages/YatraPressRelease/10022025-nasik";
import DELHI_23012025 from "../pages/YatraPressRelease/23012025-delhi";
import COIMBATORE_05022025 from "../pages/YatraPressRelease/05022025-coimbatore";
import PRAYAGRAJ_24012025 from "../pages/YatraPressRelease/24012025-prayagraj";
import KailashKherEventComponent from "../pages/Events/20250418_KailashKher";
import MainEventPage from "../pages/Events/MainEventPage";
import UpcomingEventsComponent from "../pages/Events/UpcomingEvents";



const AppRoutes = () => {
  return (
    <div>
      <LanguageProvider>
        <Header />
        <Routes>
          <Route>
            <Route path="/" element={<Home />} />
            <Route
              path="/explore-our-mission"
              element={<ExploreOurMission />}
            />
            <Route path="/adopt-now" element={<AdoptNow />} />
            <Route path="/adopt-a-cow" element={<AdoptACowForm />} />
            <Route path="/adopt-a-tree" element={<AdoptATreeForm />} />
            <Route path="/adopt-a-temple" element={<AdoptATempleForm />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/join-as-a-volunteer" element={<JoinAsAVolunteer />} />
            <Route path="/join-as-a-donar" element={<JoinAsADonor />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route
              path="/join-as-a-committie-member"
              element={<JoinAsCommittieMember />}
            />
            <Route path="/donation" element={<Donation />} />
            <Route
              path="/heritage-developement"
              element={<HeritageDevelopmentCommittee />}
            />
            <Route
              path="/community-upliftment"
              element={<CommunityUpliftmentCommittee />}
            />
            <Route path="/vikas-committee" element={<VikasCommittee />} />
            <Route
              path="/bharat-jal-sanrakshan-committee"
              element={<BharatJalSanrakshanCommittee />}
            />
            <Route
              path="/shakti-bharat-mission"
              element={<ShaktiBharatMissionCommitte />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/mahasangam-yatra" element={<MahasangamYatra />} />

            <Route path="/register-temple" element={<RegisterTempleForm />} />
            <Route path="/join-as-a-pujari" element={<JoinAsAPujari />} />
            <Route path="/puja-shops" element={<PujaShops />} />
            <Route path="/reports/volunteer" element={<VolunteerReport />} />
            <Route path="/reports/donor" element={<DonorReport />} />
            <Route path="/reports/pujari" element={<PujariReport />} />
            <Route path="/reports/puja-shops" element={<PujashopReport />} />
            <Route
              path="/reports/temples"
              element={<TempleRegistrationReport />}
            />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route
              path="/bhagva-trishool-yatra/13032025/sisaye"
              element={<SISAYE_13_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/13032025/mahipalpur"
              element={<MAHIPALPUR_13_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/12032025/jind"
              element={<JIND_12_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/12032025/hisar"
              element={<HISAR_12_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/08032025/haridwar"
              element={<HARIDWAR_08_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/07032025/haridwar"
              element={<HARIDWAR_07_MAR_2025 />}
            />

            <Route
              path="/bhagva-trishool-yatra/07032025/meerut"
              element={<MEERUT_07_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/06032025/badayuAurSambal"
              element={<BADAYU_06_MAR_2025 />}
            />

            <Route
              path="/bhagva-trishool-yatra/03032025/ayodhya"
              element={<AYODHYA_03_MAR_2025 />}
            />
             <Route
              path="/bhagva-trishool-yatra/24022025/delhi"
              element={<DELHI_24_FEB_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/05032025/badayu-sambhal"
              element={<BADAYU_05_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/05032025/sambhal"
              element={<SAMBAL_05_MAR_2025 />}
            />
             <Route
              path="/all-releases"
              element={<AllReleases />}
            />
            <Route
              path="/bhagva-trishool-yatra/02032025/prayagraj"
              element={<PRAYAGRAJ_02_MAR_2025 />}
            />
            <Route
              path="/bhagva-trishool-yatra/27022025/delhi"
              element={<DELHI_27_FEB_2025 />}
            />
            <Route
              path="/mahasangam-press-release/29012025/puri"
              element={<ODISHA_PURI_29012025 />}
            />
            <Route
              path="/mahasangam-press-release/30012025/bhubaneshwar"
              element={<ODISHA_BHUBNESHWAR_29012025 />}
            />
            <Route
              path="/mahasangam-press-release/05022025/ranchi"
              element={<RANCHI_05022025 />}
            />
            <Route
              path="/mahasangam-press-release/12022025/somnath-temple"
              element={<SOMNATH_TEMPLE_12022025 />}
            />
            <Route
              path="/mahasangam-press-release/05022025/rameswaram"
              element={<RAMESWARAN_05022025 />}
            />
            
             <Route
              path="/mahasangam-press-release/-/agra"
              element={<AGRA_ />}
            />
            <Route
              path="/mahasangam-press-release/14022025/ahmedabad"
              element={<AHMEDABAD_14022025 />}
            />
            <Route
              path="/mahasangam-press-release/01022025/andhrapradesh"
              element={<ANDHRAPRADESH_01022025 />}
            />
            <Route
              path="/mahasangam-press-release/08022025/maharashtra"
              element={<MAHARASHTRA_BHIMSHANKAR_08022025 />} 
            />
            <Route
              path="/mahasangam-press-release/-/gujrat-dwarka"
              element={<GUJRAT_DWARKA />} 
            />
            <Route
              path="/mahasangam-press-release/10022025/delhi"
              element={<DELHI_SOMNATH_10022025 />} 
            />
             <Route
              path="/mahasangam-press-release/12022025/surat"
              element={<SURAT_12022025 />} 
            />
             <Route
              path="/mahasangam-press-release/12022025/surat"
              element={<UJJAIN_12022025 />} 
            />
            <Route
              path="/mahasangam-press-release/03022025/andhrapradesh"
              element={<ANDHRAPRADESH_03022025 />} 
            />
             <Route
              path="/mahasangam-press-release/10022025/delhi"
              element={<DELHI_10022025 />} 
            />
            
            <Route
              path="/mahasangam-press-release/10022025/nasik"
              element={<NASIK_10022025 />} 
            />
            
            <Route
              path="/mahasangam-press-release/23012025/delhi"
              element={<DELHI_23012025 />} 
            />
             <Route
              path="/mahasangam-press-release/05022025/coimbatore"
              element={<COIMBATORE_05022025 />} 
            />

            <Route
              path="/mahasangam-press-release/24012025/pyragraj"
              element={<PRAYAGRAJ_24012025 />} 
            />

            <Route path="/test-home" element={<Home2 />} />
            <Route path="/events" element={<MainEventPage />} />
            <Route path="/20250418/kailash-kher" element={<KailashKherEventComponent />} />
            <Route path="/event-registration" element={<EventRegistration />} />
            <Route path="/reports/event-registration" element={<EventRegistrationReport />} />
            <Route path="/our-events" element={<AllEventsGallery />} />

            {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
          </Route>
        </Routes>
        <Footer />
      </LanguageProvider>
    </div>
  );
};

export default AppRoutes;
